import React from "react";
import PropTypes from "prop-types";

// Components
import Link from "./Link";

const LinkWrapper = ({ isShown, to, className, children, ...props }) =>
  isShown ? (
    <Link to={to} className={className} {...props}>
      {children}
    </Link>
  ) : (
    children
  );

LinkWrapper.propTypes = {
  isShown: PropTypes.bool,
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
      state: PropTypes.object,
    }),
  ]),
  className: PropTypes.any,
  children: PropTypes.any,
};

export default LinkWrapper;
